import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { resetBooking } from "../features/bookingSlice/bookingSlice";
import PremiumLoader from "../components/PremiumLoader";

const ThankYouPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState(null);
  const [bookingId, setBookingId] = useState(null);
  const [paymentData, setPaymentData] = useState(null);
  // eslint-disable-next-line no-unused-vars
  const [bookingData, setBookingData] = useState(null);

  const { booking_id } = useSelector((state) => state.booking);
  const stateData = location.state;

  useEffect(() => {
    const completeBooking = async () => {
      if (stateData?.bookingRefId) {
        setBookingId(stateData.bookingRefId);
        setBookingData(stateData.bookingData);
        setPaymentData(stateData.paymentResult);
        setMessage("Your corporate transfer has been confirmed and registered in our dispatch system!");
        setLoading(false);
        dispatch(resetBooking());
        return;
      }

      if (booking_id) {
        setBookingId(booking_id);
        setMessage("Your corporate transfer has been confirmed successfully!");
        setLoading(false);
        dispatch(resetBooking());
        return;
      }

      setMessage("No booking information found.");
      setLoading(false);
      setTimeout(() => {
        navigate('/');
      }, 3000);
    };

    completeBooking();
  }, [booking_id, dispatch, stateData, navigate]);

  if (loading) return <PremiumLoader />;

  return (
    <main className="min-h-screen bg-[#0b132b] text-slate-100 flex flex-col items-center justify-center p-4 sm:p-6 lg:p-8">
      <div className="w-full max-w-2xl bg-slate-900/90 border border-slate-700/80 rounded-3xl p-8 sm:p-12 shadow-2xl backdrop-blur-xl text-center space-y-6">
        
        {/* Success Icon */}
        <div className="w-20 h-20 rounded-2xl bg-emerald-500/20 text-emerald-400 border border-emerald-500/40 flex items-center justify-center mx-auto shadow-lg shadow-emerald-500/20">
          <span className="material-symbols-outlined !text-4xl">check_circle</span>
        </div>

        {/* Header */}
        <div>
          <span className="text-xs font-bold uppercase tracking-widest text-blue-400">Reservation Confirmed</span>
          <h1 className="text-3xl sm:text-4xl font-black text-white mt-1">Thank You For Your Booking</h1>
          <p className="text-slate-400 text-sm mt-2">{message}</p>
        </div>

        {/* Ref ID Badge */}
        {bookingId && (
          <div className="p-4 rounded-xl bg-slate-950/80 border border-slate-800 inline-block">
            <span className="text-[11px] font-bold text-slate-400 uppercase tracking-wider block mb-1">Booking Reference Number</span>
            <span className="text-2xl font-black text-blue-400 font-mono tracking-wider">{bookingId}</span>
          </div>
        )}

        {/* Details Grid */}
        <div className="text-left bg-slate-950/70 border border-slate-800 rounded-2xl p-6 space-y-3.5 text-xs text-slate-300">
          <div className="flex justify-between items-center pb-3 border-b border-slate-800">
            <span className="text-slate-400">Dispatch Status</span>
            <span className="text-emerald-400 font-bold flex items-center gap-1.5">
              <span className="w-2 h-2 rounded-full bg-emerald-400 animate-pulse" />
              Chauffeur Assigned / Queued
            </span>
          </div>
          
          <div className="flex justify-between items-center">
            <span className="text-slate-400">Payment Authorization</span>
            <span className="text-white font-mono font-medium">
              {paymentData?.status === 'BOARDING' ? 'Pay on Boarding' : 'Authorized via Square'}
            </span>
          </div>

          <div className="flex justify-between items-center">
            <span className="text-slate-400">Flight Radar Sync</span>
            <span className="text-blue-400 font-medium">Active (Continuous Monitoring)</span>
          </div>

          <div className="flex justify-between items-center">
            <span className="text-slate-400">Confirmation Delivery</span>
            <span className="text-white font-medium">Email & SMS Dispatched</span>
          </div>
        </div>

        {/* Actions */}
        <div className="pt-4 flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            onClick={() => navigate('/')}
            className="w-full sm:w-auto px-8 py-3.5 rounded-xl exec-btn-primary text-xs uppercase font-extrabold tracking-wider shadow-lg flex items-center justify-center gap-2"
          >
            <span className="material-symbols-outlined !text-base">add</span>
            Book Another Transfer
          </button>
          <a
            href="tel:6174997770"
            className="w-full sm:w-auto px-6 py-3.5 rounded-xl bg-slate-800 hover:bg-slate-700 text-white text-xs uppercase font-bold tracking-wider border border-slate-700 transition-all flex items-center justify-center gap-2"
          >
            <span className="material-symbols-outlined !text-base">phone_in_talk</span>
            Contact Dispatch (617) 499-7770
          </a>
        </div>

      </div>
    </main>
  );
};

export default ThankYouPage;
